<template>
    <div class="round-quote">
        <div class="rotation" ref="rotation">
            <div
                class="rotation-box"
                ref="rotationBox"
                v-for="(item, index) in roundCard"
                :key="index"
                :class="active == index ? 'active' : ''"
                :style="{ transform: 'translate(' + moveX + 'px)' }"
                @click="handScroll(index)"
            >
                <div class="box-top">
                    <p class="top-title">第{{ item.roundCurrent }}轮</p>
                    <p class="top-type">{{ item.tenderStatus_ }}</p>
                </div>
                <div class="box-bottom">
                    <p class="bottom-title">洽谈编码</p>
                    <p class="bottom-text">{{ item.tenderCode }}</p>
                    <p class="bottom-title">洽谈类型</p>
                    <p class="bottom-text">{{ item.quoteType_ }}</p>
                </div>
            </div>
        </div>
        <div>
            <div class="quote-button">
                <div>
                    <span class="btn-span" v-has="'02010036'">
                        <el-button class="bigData-btn-save" type="primary" :loading="loadHeadSave" :disabled="statusBtn" @click="saveData">保存</el-button>
                    </span>
                    <span class="btn-span" v-has="'02010037'">
                        <el-button class="bigData-btn-release" type="primary" :loading="publishDataLoad" :disabled="statusBtn" @click="publishData">发布</el-button>
                    </span>
                    <span class="btn-span" v-has="'02010038'">
                        <el-button class="bigData-btn-overtime" type="primary" :disabled="timeBtn" @click="addTime">报价加时</el-button>
                    </span>
                    <span class="btn-span" v-has="'02010039'">
                        <el-button class="bigData-btn-result" type="primary" @click="tenderResult('tenderresult')">查看招标结果</el-button>
                    </span>
                    <span class="btn-span" v-has="'02010040'">
                        <el-button class="bigData-btn-publish" type="primary" :loading="bidPriceLoad" :disabled="bidPriceBtn" @click="bidPrice">公布拦标价</el-button>
                    </span>
                    <span class="btn-span" v-has="'02010041'">
                        <el-button class="bigData-btn-initiate" type="primary" :loading="nextRoundLaod" :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH'] || nextBtn"
                            @click="nextRound">发起下一轮</el-button>
                    </span>
                    <span class="btn-span" v-has="'02010068'">
                        <el-button class="bigData-btn-monitor" type="primary" :disabled="!form.tenderCode" @click="earlyWarning">轮次报价监控</el-button>
                        </span>
                    <span class="btn-span" v-has="'02010069'">
                        <el-button class="bigData-btn-delete" type="primary" :disabled="loginState.bidStatus !== BID_STATUS['BIDPUBLISH']" @click="delOneRound">删除第一轮</el-button>
                    </span>
                    <span class="btn-span" v-if="form.quoteType === TENDER_TYPE['BIDDING']">
                        <el-button class="bigData-btn-check" type="primary" @click="seeFunc">查看报价</el-button>
                    </span>
                    <span v-has="'02010078'" v-if="form.roundCurrent === 1">
                        <el-button class="bigData-btn-add" type="primary" @click="AddsupplierFn">添加供应商</el-button>
                    </span>
                </div>
                <div class="dtTime" v-if="form.tenderStatus === TENDER_STATUS['PUBILSH'] && form.quoteType === TENDER_TYPE['BIDDING'] && countTimesFlag">
                    倒计时：{{ countTimes }}
                </div>
            </div>
            <div class="quote-input">
                <el-form
                    :model="form"
                    label-width="150px"
                    ref="ruleForm"
                    :rules="rules"
                    class="wrapper-form"
                >
                    <el-form-item
                        class="item"
                        label="洽谈开始时间"
                        prop="effectDateFrom"
                    >
                        <el-date-picker
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptionsStart"
                            v-model="form.effectDateFrom"
                            type="datetime"
                            placeholder="0000-00-00 00:00"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                        class="item"
                        label="洽谈结束时间"
                        prop="effectDateTo"
                    >
                        <el-date-picker
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptionsStart"
                            v-model="form.effectDateTo"
                            type="datetime"
                            placeholder="0000-00-00 00:00"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                        class="item"
                        label="洽谈类型"
                        prop="quoteType"
                        v-if="form.tenderStatus === TENDER_STATUS['NEW']"
                    >
                        <MSelect
                            :optionNum="'BID_SU_TENDER_TYPE'"
                            :value="form.quoteType"
                            :filterable="true"
                            @input="getQuoteType"
                        ></MSelect>
                    </el-form-item>
                    <el-form-item
                        v-if="form.quoteType === TENDER_TYPE['BIDDING']"
                        class="item"
                        label="实际报价结束时间"
                        prop="effectDateTo"
                    >
                        <el-date-picker
                            disabled
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptionsStart"
                            v-model="form.effectDateTo"
                            type="datetime"
                            placeholder="0000-00-00 00:00"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                        v-if="form.quoteType === TENDER_TYPE['BIDDING']"
                        class="item"
                        label="预警时间（分）"
                        prop="prewarningTime"
                    >
                        <el-input-number
                            v-model="form.prewarningTime"
                            :precision="2"
                            controls-position="right"
                            :step="1"
                            :min="0"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item
                        v-if="form.quoteType === TENDER_TYPE['BIDDING']"
                        class="item"
                        label="报价最低降幅%"
                        prop="minimumDecline"
                    >
                        <el-input-number
                            v-model="form.minimumDecline"
                            :precision="2"
                            controls-position="right"
                            :step="1"
                            :min="0"
                            :max="100"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item
                        v-if="form.quoteType !== TENDER_TYPE['BIDDING']"
                        class="item"
                        label="报价低于上轮"
                        prop="lowerLastRound"
                    >
                        <MSelect
                            :optionNum="'BID_LOWER_LAST_ROUND'"
                            :value="form.lowerLastRound"
                            :filterable="true"
                            @input="getLowerLastRound"
                        ></MSelect>
                    </el-form-item>
                    <el-form-item
                        class="item"
                        label="最小出价变化量"
                        prop="changeBidMin"
                    >
                        <el-input-number
                            v-model="form.changeBidMin"
                            :precision="form.quotePrecision"
                            controls-position="right"
                            :step="1"
                            :min="0"
                            :max="9999999"
                            :disabled="form.lowerLastRound === LOWER_LAST_ROUND['BYPACKAGE']"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item
                        class="item"
                        label="报价小数位"
                        prop="quotePrecision"
                    >
                        <el-input-number
                            v-model="form.quotePrecision"
                            controls-position="right"
                            :step="1"
                            :min="0"
                            :max="4"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item
                        class="item"
                        label="自身排名可见"
                        prop="rankVisible"
                    >
                        <MSelect
                            :optionNum="'BID_RANK_VISIBLE'"
                            :value="form.rankVisible"
                            :filterable="true"
                            @input="getRankVisible"
                        ></MSelect>
                    </el-form-item>
                    <el-form-item
                        class="item"
                        label="最低价是否可见"
                        prop="lowestQuoteVisible"
                        v-if="form.quoteType !== TENDER_TYPE['BIDDING']"
                    >
                        <MSelect
                            :optionNum="'BID_YES_NO'"
                            :value="form.lowestQuoteVisible"
                            :filterable="true"
                            @input="getLowestQuoteVisible"
                        ></MSelect>
                    </el-form-item>
                    <el-form-item class="item" label="本轮次供应商数量">
                        <el-input-number
                            v-model="form.currentSuppliers"
                            controls-position="right"
                            :disabled="true"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item class="item" label="提交报价供应商数量">
                        <el-input-number
                            v-model="form.supplierQuote"
                            controls-position="right"
                            :disabled="true"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item
                        class="item"
                        label="是否控制拦标价"
                        prop="blockPriceControl"
                    >
                        <MSelect
                            :disabled="form.roundCurrent === 1"
                            :optionNum="'BID_YES_NO'"
                            :value="form.blockPriceControl"
                            @input="getBlockPriceControl"
                        ></MSelect>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="quote-select">
            <div class="quote-select-left">
                <el-input
                    placeholder="请输入标段名称查询，多个则使用逗号分隔"
                    v-model="extStr1s"
                    clearable
                    class="select-input bd-name-input"
                ></el-input>
                <el-input
                    placeholder="供应商名称"
                    v-model="supplierName"
                    clearable
                    class="select-input sup-name-input"
                ></el-input>
                <span class="select-label">是否允许报价：</span>
                <MSelect
                    class="select-input"
                    :optionNum="'BID_YES_NO'"
                    :value="allowQuote"
                    :filterable="true"
                    @input="getAllowQuote"
                ></MSelect>
                <span class="select-label">是否提交报价：</span>
                <MSelect
                    class="select-input"
                    :optionNum="'BID_IS_SUBMIT'"
                    :value="tenderStatus"
                    :filterable="true"
                    @input="getTenderStatus"
                ></MSelect>
                <span class="select-label">中标状态：</span>
                <MSelect
                    class="select-input"
                    :optionNum="'BID_WON_STATUS'"
                    :value="shortlist"
                    :filterable="true"
                    @input="getShortlist"
                ></MSelect>
                <span v-has="'02010042'">
                    <el-button
                    class="bigData-btn-search"
                        type="primary"
                        :loading="tableLoad"
                        @click="selectData"
                        >查询</el-button>
                </span>
                <span class="quote-select-button">
                    <el-button
                        class="bigData-btn-referenceCost"
                        v-if="['3', '4', '5', '10'].includes(loginState.businessType)"
                        @click="checkCost"
                        >查看参考成本</el-button>
                </span>
                <span class="quote-select-button" v-if="loginState.businessType === BUSINESS_TYPE['DOCK']">
                    <el-button
                        class="bigData-btn-handlingPrice"
                        @click="linkDockModel"
                        >装卸核价模型</el-button>
                </span>
                <span class="quote-select-button" v-if="standardCostVisible">
                    <el-button class="bigData-btn-match" type="primary" :loading="standardCostLoading" @click="handleMatchStandardCost">匹配标准成本按钮</el-button>
                </span>
            </div>
            <div class="quote-select-right">
                <el-dropdown
                    @command="handleCommand"
                    v-has="'02010043'"
                    trigger="click"
                >
                    <span class="el-dropdown-link">
                        导出<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="round-quote-el-dropdown-menu">
                        <el-dropdown-item :command="currentDetails" :disabled="cdLoading"><el-button type="text" :loading="cdLoading">导出当前轮次报价明细</el-button></el-dropdown-item>
                        <el-dropdown-item :command="allDetails" :disabled="adLoading"><el-button type="text" :loading="adLoading">导出所有报价明细</el-button></el-dropdown-item>
                        <el-dropdown-item :command="currentResult" :disabled="crLoading"><el-button type="text" :loading="crLoading">导出当前轮次报价结果</el-button></el-dropdown-item>
                        <el-dropdown-item :command="allResult" :disabled="arLoading"><el-button type="text" :loading="arLoading">导出所有报价结果</el-button></el-dropdown-item>
                        <el-dropdown-item v-if="loginState.isShowTab" :command="exportNowScore" :disabled="nsLoading">
                            <el-button type="text" :loading="nsLoading">导出当前轮次报价综合分</el-button></el-dropdown-item>
                        <el-dropdown-item v-if="loginState.isShowTab" :command="exportAllScore" :disabled="asLoading">
                            <el-button type="text" :loading="asLoading">导出所有报价综合分</el-button></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="tag">
            <span v-has="'02010044'">
                <el-button
                    type="text"
                    class="tag-tips"
                    @click="startTender"
                    :loading="startTenderLoad"
                    :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH'] || timeBtn"
                    >开标</el-button>
            </span>
            <span v-has="'02010045'" >
                <el-button
                    type="text"
                    class="tag-tips"
                    @click="batchBid"
                    :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH']|| timeBtn"
                    >分批开标</el-button>
            </span>
            <span v-has="'02010046'">
                <el-button
                    type="text"
                    class="tag-tips"
                    @click="bidShortlist"
                    :loading="bidShortlistLoad"
                    :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH'] || nextBtn"
                    >入围</el-button>
                </span>
            <span v-has="'02010047'">
                <el-button
                    type="text"
                    class="tag-tips"
                    @click="autoShortlist"
                    :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH'] || nextBtn"
                    >自动入围</el-button>
            </span>
            <span v-has="'02010048'">
                <el-button
                    type="text"
                    class="tag-tips"
                    @click="notShortlist"
                    :loading="loadNot"
                    :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH'] || nextBtn"
                    >未入围</el-button>
            </span>
            <span v-has="'02010049'">
                <el-button
                    type="text"
                    class="tag-tips"
                    :loading="winBidLoad"
                    :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH'] || nextBtn"
                    @click="winBid"
                    >中标</el-button>
            </span>
            <span v-has="'02010050'">
                <el-button
                    type="text"
                    class="tag-tips"
                    :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH'] || nextBtn"
                    @click="flowBid"
                    >流标</el-button>
            </span>
            <span v-has="'02010051'">
                <el-button
                    type="text"
                    class="tag-tips"
                    :loading="loadAbandon"
                    :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH'] || nextBtn"
                    @click="abandonBid"
                    >弃标</el-button>
            </span>
            <span v-has="'02010052'">
                <el-button
                    type="text"
                    class="tag-tips"
                    v-if="this.form.quoteType !== TENDER_TYPE['ELECTRONIC']"
                    :loading="loadSave"
                    :disabled="headerMsg.bidStatus !== BID_STATUS['BIDPUBLISH']"
                    @click="saveDteails"
                    >保存</el-button>
            </span>
        </div>
        <div class="quote-table">
            <roundTable
                :allowQuote="allowQuote"
                :tableLoad="tableLoad"
                :tableData="tableData"
                :tableHeaders="tableHeaders"
                :form="form"
                :selectAllType="selectAllType"
                :dictData="dictData"
                @selectAllChange="selectAllChange"
                @load="loadFn"
            ></roundTable>
        </div>
        <add-time-dialog
            v-if="showAddTimeDialog"
            :showAddTimeDialog.sync="showAddTimeDialog"
            :version="form.version"
            :form="form"
            :id="form.id"
            @getData="getData"
        ></add-time-dialog>
        <batch-bid-dialog
            v-if="showBatchBidDialog"
            :showBatchBidDialog.sync="showBatchBidDialog"
            :formData="this.form"
            :bidNo="bidNo"
            @getBidData="getData"
        ></batch-bid-dialog>
        <auto-shortlist-dialog
            v-if="showAutoShortlist"
            :showAutoShortlist.sync="showAutoShortlist"
            :tenderCode="form.tenderCode"
            :syntheticalScore="headerMsg.syntheticalScore"
            :tableData="tableData"
            @updateData="getTableData"
        ></auto-shortlist-dialog>
        <won-failed-dialog
            v-if="showWonFailedDialog"
            :showWonFailedDialog.sync="showWonFailedDialog"
            :tenderCode="form.tenderCode"
            :bidNo="bidNo"
            @updateTableData="getTableData"
        ></won-failed-dialog>
        <roundWarning
            :warnShowFlag="warnShowFlag"
            :tenderCode="form.tenderCode"
            @warnShowFunc="warnShowFunc"
        ></roundWarning>
        <consult-cost-dialog
            v-if="showConsultCostDialog"
            :showConsultCostDialog.sync="showConsultCostDialog"
            :params="consultCostParams"
        ></consult-cost-dialog>
        <customAdvance
            ref="customAdvance"
            @confirm="custemConfirm"
        ></customAdvance>
        <SeeOfferDialog
            :seeOfferVisible.sync="seeOfferVisible"
            :tenderCode="form.tenderCode"
            :bidNo="bidNo"
            :managementSide="true"
            :currentList="currentList"
        ></SeeOfferDialog>
        <Addsupplier :showAddSupplier.sync="showAddSupplier" :tenderCode="form.tenderCode" :bidNo="bidNo"></Addsupplier>
    </div>
</template>
<script>
import roundQuote from './roundQuote.js';
export default roundQuote;
</script>
<style lang="less">
@import url("./roundQuote.less");
</style>